import swal from "sweetalert";
import { jsPDF } from "jspdf";

import { isTouchEnabled } from "@/App.vue";
import { getFormattedDate, saveFile } from "@/components/reports/fileMethods";
import { getImgDataForCurrentView } from "@/components/reports/ReportsManager";
import {
  debugAnchorageResult,
  generateRootCrownMeshes,
  getMeshesBox,
  calculateAnchorAreas,
  calculateAnchorObj,
  getLessNeighborTooth,
  areAllIncisors,
  areAnyIncisors,
} from "./AnchorageCalculation";
import {
  getTeethBox,
  getTeethZoom,
  switchToMaxilla,
  switchToMandibular,
} from "../occlusal/OcclusalTools.js";
import {
  drawBox,
  drawLine,
  drawPoint,
  drawDraggableArrow,
  updateDraggableArrow,
} from "../draw/draw.js";
import { switchStitching } from "@/components/appStart/stitching";
import AnchorageWizard from "./AnchorageWizard.vue";
import { enterAnchorageAnimationMode } from "./AnchorageAnimation.js";

//#region  Fields
let controlsInitialized = false;
let anchorViewersInitialized = false;

let allTeethBox = null;
let allTeethCenter = null;

let maxillaCenter = null;
let maxillaBox = null;
let maxillaZoom = null;

let mandibleCenter = null;
let mandibleBox = null;
let mandibleZoom = null;

let anchorageScene1 = null;
let anchorageScene2 = null;
let anchorageCamera1 = null;
let anchorageCamera2 = null;
let anchorageControls1 = null;
let anchorageControls2 = null;

let documentWidth = null;
let documentHeight = null;

const mainColor = "#00FFFF";
const opposingColor = "#00FF00";

let view_dy = 3;
let view_dz = 6;
let cameraDistance = 22;

let isUpper1 = false;
let isUpper2 = false;

let moveArrow1 = null;
let moveArrow2 = null;
const arrowSize = 0.5;
const draggableTag = "draggable";
const minArrowLength = 15;
let isArrowDragging = false;
let draggingArrow = null;
let draggPoint = null;
let dragDif = new THREE.Vector3();

let anchorContext = {
  isMove1: false,
  isMove2: false,
  isDirectionEnabled: false,
};

//#endregion

//#region enterAnchorageMode

function enterAnchorageMode() {
  console.log("enterAnchorageMode");
  vueApp.leaveModes(false, false, false);
  if (!controlsInitialized) {
    const componentInstance = new Vue({
      ...AnchorageWizard,
      propsData: { context: anchorContext },
    });
    const vueContainer = document.createElement("div");
    let wrapper = document.getElementById("views_cont");
    wrapper.appendChild(vueContainer);
    componentInstance.$mount(vueContainer);
    controlsInitialized = true;
  }

  $("#anchorageWizard").modal();
  $(".anchorage-load-spinner").css({ display: "block" });
  $("#anchorageSpinner").css({ display: "none" });
  setTimeout(
    function () {
      generateRootCrownMeshes();
      initAnchorViewers();
    },
    !anchorViewersInitialized ? 300 : 10,
  );
}

function setCenters() {
  let rect = document.getElementById("views_cont").getBoundingClientRect();
  documentWidth = rect.width;
  documentHeight = rect.height;
  // console.log("setCenters", rect, documentWidth, documentHeight);

  allTeethBox = offsetBox(getMeshesBox(vueApp.teethMeshes));
  allTeethCenter = new THREE.Vector3(
    allTeethBox.center.x,
    allTeethBox.center.y,
    allTeethBox.min.z + view_dz * 2,
  );

  maxillaBox = offsetBox(getTeethBox(true));
  maxillaCenter = new THREE.Vector3(
    maxillaBox.center.x,
    maxillaBox.min.y + view_dy,
    maxillaBox.min.z + view_dz * 2,
  );
  maxillaZoom = getTeethZoom(maxillaBox) * 1.2; // / 2;

  mandibleBox = offsetBox(getTeethBox(false));
  mandibleCenter = new THREE.Vector3(
    mandibleBox.center.x,
    mandibleBox.max.y - view_dy * 1.8,
    mandibleBox.min.z + view_dz * 2,
  );
  mandibleZoom = getTeethZoom(mandibleBox) * 1.2; // / 2;
}

function initAnchorViewers() {
  if (!anchorViewersInitialized) {
    setCenters();

    let containers = ["anchorage1Viewer", "anchorage2Viewer"];

    containers.forEach((containerId, index) => {
      const container = document.getElementById(containerId);
      const scene = createScene(container, index);
      vueApp.allTeeth.forEach((tooth) => {
        let toothMesh = viewer.get_model_mesh(tooth.id);
        let toothGeometry = toothMesh.stitchedGeometry
          ? toothMesh.stitchedGeometry
          : toothMesh.geometry;
        let anchorageMesh = new THREE.Mesh(
          toothGeometry.clone(),
          toothMesh.originalMaterial.clone(),
        );
        anchorageMesh.material.color = new THREE.Color("#FFFFFF");
        // anchorageMesh.material.opacity = 0.5;
        scene.add(anchorageMesh);
        anchorageMesh.position.copy(toothMesh.position);
        anchorageMesh.rotation.copy(toothMesh.rotation);
        anchorageMesh.visible = toothMesh.visible && tooth.isUpper; // == !index;

        anchorageMesh.model = tooth;
        anchorageMesh.mainMesh = toothMesh;

        if (!toothMesh.anchorageMeshes) {
          toothMesh.anchorageMeshes = [];
        }
        toothMesh.anchorageMeshes.push(anchorageMesh);
      });

      if (isTouchEnabled()) {
        container.addEventListener("touchstart", function (e) {
          var event = e.targetTouches[0];
          onAnchorViewerMouseDown(event, container, scene, index);
        });
      } else {
        container.addEventListener(
          "mousedown",
          function (e) {
            onAnchorViewerMouseDown(e, container, scene, index);
          },
          false,
        );
        container.addEventListener(
          "mousemove",
          function (e) {
            onAnchorViewerMouseMove(e, container, scene, index);
          },
          false,
        );
        container.addEventListener(
          "mouseleave",
          function (e) {
            isArrowDragging = false;
          },
          false,
        );
        container.addEventListener(
          "mouseup",
          function (e) {
            isArrowDragging = false;
          },
          false,
        );
      }
    });

    switchToMaxilla1();
    switchToMaxilla2();

    anchorViewersInitialized = true;
  } else {
    anchorContext.isDirectionEnabled =
      anchorContext.isMove1 =
      anchorContext.isMove2 =
        false;
    if (moveArrow1) {
      anchorageScene1.remove(moveArrow1);
    }
    if (moveArrow2) {
      anchorageScene2.remove(moveArrow2);
    }

    anchorageScene1.children
      .concat(anchorageScene2.children)
      .forEach((anchorageMesh) => {
        if (anchorageMesh.model && anchorageMesh.material) {
          let mainMesh = anchorageMesh.mainMesh;
          if (
            !vueApp.allTeeth.includes(anchorageMesh.model) &&
            !viewer.scene.children.includes(mainMesh)
          ) {
            anchorageMesh.visible = false;
            return;
          }

          let isMesh1 = anchorageScene1.children.includes(anchorageMesh);
          anchorageMesh.isSelected = false;
          anchorageMesh.material.color = new THREE.Color("#FFFFFF");

          anchorageMesh.position.copy(mainMesh.position);
          anchorageMesh.rotation.copy(mainMesh.rotation);
          anchorageMesh.visible = mainMesh.visible; // anchorageMesh.model.isUpper;
          if (anchorageMesh.visible) {
            let modelUpper = anchorageMesh.model.isUpper;
            anchorageMesh.visible = isMesh1
              ? modelUpper == isUpper1
              : modelUpper == isUpper2;
          }
          let originalMaterial = mainMesh.originalMaterial
            ? mainMesh.originalMaterial
            : mainMesh.material;
          anchorageMesh.material.opacity = originalMaterial.opacity;
        }
      });
  }
  $(".anchorage-load-spinner").css({ display: "none" });
}

//#endregion

//#region Occlusal

function switchToMaxilla1() {
  if (moveArrow1) {
    anchorageScene1.remove(moveArrow1);
  }

  isUpper1 = true;
  vueApp.allTeeth.forEach((tooth) => {
    let toothMesh = viewer.get_model_mesh(tooth.id);
    if (toothMesh.anchorageMeshes) {
      toothMesh.anchorageMeshes[0].visible = toothMesh.visible && tooth.isUpper;
    }
  });

  switchViewerToMaxilla(anchorageCamera1, anchorageControls1);
}

function switchToMandibular1() {
  if (moveArrow1) {
    anchorageScene1.remove(moveArrow1);
  }
  isUpper1 = false;
  vueApp.allTeeth.forEach((tooth) => {
    let toothMesh = viewer.get_model_mesh(tooth.id);
    if (toothMesh.anchorageMeshes) {
      toothMesh.anchorageMeshes[0].visible =
        toothMesh.visible && !tooth.isUpper;
    }
  });

  switchViewerToMandibular(anchorageCamera1, anchorageControls1);
}

function switchToMaxilla2() {
  if (moveArrow2) {
    anchorageScene2.remove(moveArrow2);
  }

  isUpper2 = true;
  vueApp.allTeeth.forEach((tooth) => {
    let toothMesh = viewer.get_model_mesh(tooth.id);
    if (toothMesh.anchorageMeshes) {
      toothMesh.anchorageMeshes[1].visible = toothMesh.visible && tooth.isUpper;
    }
  });

  switchViewerToMaxilla(anchorageCamera2, anchorageControls2);
}

function switchToMandibular2() {
  if (moveArrow2) {
    anchorageScene2.remove(moveArrow2);
  }
  isUpper2 = false;
  vueApp.allTeeth.forEach((tooth) => {
    let toothMesh = viewer.get_model_mesh(tooth.id);
    if (toothMesh.anchorageMeshes) {
      toothMesh.anchorageMeshes[1].visible =
        toothMesh.visible && !tooth.isUpper;
    }
  });

  switchViewerToMandibular(anchorageCamera2, anchorageControls2);
}

function switchViewerToMaxilla(camera, controls) {
  let teethBox = maxillaBox;
  let teethZoom = maxillaZoom;

  camera.position.x = teethBox.center.x;
  camera.position.y =
    teethBox.center.y -
    (documentWidth > documentHeight ? teethZoom : teethZoom / 2);
  camera.position.z = teethBox.center.z;
  camera.up.y = 0;
  camera.up.x = 0;
  camera.up.z = 1;

  let point = teethBox.center;
  camera.lookAt(point.x, point.y, point.z);
  controls.target = new THREE.Vector3(point.x, point.y, point.z);
}

function switchViewerToMandibular(camera, controls) {
  let teethBox = mandibleBox;
  let teethZoom = mandibleZoom;

  camera.position.x = teethBox.center.x;
  camera.position.y =
    teethBox.center.y +
    (documentWidth > documentHeight ? teethZoom : teethZoom / 2);
  camera.position.z = teethBox.center.z;
  camera.up.y = 0;
  camera.up.x = 0;
  camera.up.z = -1;
  let point = teethBox.center;
  camera.lookAt(point.x, point.y, point.z);
  controls.target = new THREE.Vector3(point.x, point.y, point.z);
}

function switchDirectionMode(move1Value, move2Value) {
  anchorContext.isMove1 = move1Value;
  if (!anchorContext.isMove1) {
    if (moveArrow1) {
      anchorageScene1.remove(moveArrow1);
    }
  }

  anchorContext.isMove2 = move2Value;
  if (!anchorContext.isMove2) {
    if (moveArrow2) {
      anchorageScene2.remove(moveArrow2);
    }
  }
}

//#endregion

//#region Scene

function createScene(container, index) {
  let rect = container.getBoundingClientRect();
  let width = rect.width;
  let height = rect.height;

  const scene = new THREE.Scene();
  if (index === 0) {
    anchorageScene1 = scene;
  } else if (index === 1) {
    anchorageScene2 = scene;
  }
  scene.background = new THREE.Color("#EEF3FF");
  scene.plane = new THREE.Mesh(
    new THREE.PlaneBufferGeometry(500, 500, 8, 8),
    new THREE.MeshBasicMaterial({
      color: 0xffffff,
      transparent: true,
      depthWrite: false,
      side: THREE.DoubleSide,
      opacity: 0.0001,
    }),
  );
  scene.add(scene.plane);

  const renderer = new THREE.WebGLRenderer();
  renderer.setSize(width, height);

  const camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 1e4);
  camera.position.x = 20;
  camera.position.z = 50;
  scene.add(camera);
  scene.camera = camera;

  scene.raycaster = new THREE.Raycaster(
    scene.camera.position,
    new THREE.Vector3(0, 0, 0),
    0.1,
    100000,
  );

  if (index === 0) {
    anchorageCamera1 = camera;
  } else if (index === 1) {
    anchorageCamera2 = camera;
  }

  addSceneLights(scene, camera);
  scene.clock = new THREE.Clock();
  scene.mixers = [];
  // camera.aspect = width / height;
  // camera.updateProjectionMatrix();
  // renderer.setSize(width, height);

  container.appendChild(renderer.domElement);
  const controls = new THREE.AstroControls(camera, renderer.domElement);
  controls.enabled = false;
  if (index === 0) {
    anchorageControls1 = controls;
  } else if (index === 1) {
    anchorageControls2 = controls;
  }
  // scene.add(new THREE.AxesHelper(180));
  // const geometry = new THREE.BoxGeometry(1, 1, 1);
  // const material = new THREE.MeshBasicMaterial({
  //   color: 0xffff00,
  //   wireframe: true,
  // });
  // const cube = new THREE.Mesh(geometry, material);
  // scene.add(cube);

  function animate() {
    if (scene.mixers && scene.mixers.length > 0) {
      const delta = scene.clock.getDelta();
      for (const mixer of scene.mixers) {
        mixer.update(delta);
      }
    }

    requestAnimationFrame(animate);
    renderer.render(scene, camera);
    controls.update();
  }
  animate();
  return scene;
}

function addSceneLights(scene, camera) {
  let ambientLight = new THREE.AmbientLight(0x202020);
  scene.add(ambientLight);

  let dirIntensity = 0.2;
  let directionalLight1 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight1.position.x = 1;
  directionalLight1.position.y = 0;
  directionalLight1.position.z = 0;
  scene.add(directionalLight1);

  let directionalLight2 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight2.position.x = 1;
  directionalLight2.position.y = 0;
  directionalLight2.position.z = 0;
  scene.add(directionalLight2);

  let directionalLight3 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight3.position.x = 0;
  directionalLight3.position.y = 0;
  directionalLight3.position.z = 1;
  scene.add(directionalLight3);

  let directionalLight4 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight4.position.x = 0;
  directionalLight4.position.y = 0;
  directionalLight4.position.z = -1;
  scene.add(directionalLight4);

  let pointLight = new THREE.PointLight(0xffffff, 0.55);
  pointLight.position.set(0, 0, 0);
  camera.add(pointLight);
}

//#endregion

//#region Events

function onAnchorViewerMouseMove(event, container, scene, viewerIndex) {
  let x = event.offsetX;
  let y = event.offsetY;
  updateAnchorRaycaster(x, y, container, scene);

  if (isArrowDragging) {
    let intersects = scene.raycaster.intersectObject(scene.plane, true);
    if (intersects.length > 0) {
      draggPoint = intersects[0].point;
      console.log("onAnchorViewerMouseMove draggPoint", draggPoint);
      let newTo = new THREE.Vector3().addVectors(draggPoint, dragDif);
      newTo.y = draggingArrow.to.y;
      updateDraggableArrow(draggingArrow, draggingArrow.from, newTo);
      draggingArrow.mainMesh.anchorDirection = new THREE.Vector3().subVectors(
        draggingArrow.to,
        draggingArrow.from,
      );
    }
  } else {
    let draggableObjs = getDraggableObjs(scene);
    let intersects = scene.raycaster.intersectObjects(draggableObjs, true);
    let isDraggable = intersects.length > 0;
    container.style.cursor = isDraggable ? "move" : "pointer";
  }
}

function getDraggableObjs(scene) {
  let draggableObjs = [];
  if (scene.children.includes(moveArrow1))
    draggableObjs.push(moveArrow1.children[0]);
  if (scene.children.includes(moveArrow2))
    draggableObjs.push(moveArrow2.children[0]);
  return draggableObjs;
}

function onAnchorViewerMouseDown(event, container, scene, viewerIndex) {
  let x = event.offsetX;
  let y = event.offsetY;
  let isScene1 = viewerIndex === 0;
  // console.log("onAnchorViewerMouseDown", x, y, container, scene);

  updateAnchorRaycaster(x, y, container, scene);

  let draggableObjs = getDraggableObjs(scene);
  let intersects = scene.raycaster.intersectObjects(draggableObjs, true);
  let isDraggable = intersects.length > 0;
  if (isDraggable) {
    draggPoint = intersects[0].point;
    scene.plane.position.copy(draggPoint);
    scene.plane.lookAt(scene.camera.position);
    isArrowDragging = true;
    draggingArrow = isScene1 ? moveArrow1 : moveArrow2;
    dragDif = dragDif.subVectors(draggingArrow.to, draggPoint);
    // dragDif.y = 0;
    console.log("dragDif", dragDif);
    return;
  }

  if (isScene1 && moveArrow1) {
    anchorageScene1.remove(moveArrow1);
  }
  if (!isScene1 && moveArrow2) {
    anchorageScene2.remove(moveArrow2);
  }

  intersects = scene.raycaster.intersectObjects(scene.children);
  for (const intersect of intersects) {
    let anchorageMesh = intersect.object;
    let tooth = anchorageMesh.model;
    if (tooth && !tooth.extracted && anchorageMesh.visible) {
      // console.log("anchorage tooth", tooth);
      if (
        (isScene1 && anchorContext.isMove1) ||
        (!isScene1 && anchorContext.isMove2)
      ) {
        if (!anchorageMesh.isSelected) return;

        let dir = getFromToDirection(tooth);
        // let scene = isScene1 ? anchorageScene1 : anchorageScene2;
        if (isScene1) {
          moveArrow1 = drawDraggableArrow(dir.from, dir.to, scene, arrowSize);
          moveArrow1.mainMesh = anchorageMesh.mainMesh;
        } else {
          moveArrow2 = drawDraggableArrow(dir.from, dir.to, scene, arrowSize);
          moveArrow2.mainMesh = anchorageMesh.mainMesh;
        }
      } else {
        let color = isScene1 ? mainColor : opposingColor;
        let isSelected = !anchorageMesh.isSelected;

        if (isSelected) {
          let oppositeScene =
            scene == anchorageScene1 ? anchorageScene2 : anchorageScene1;

          let hasOppositeSelected = !!oppositeScene.children.find(
            (c) => c.isSelected && c.model == anchorageMesh.model,
          );
          if (hasOppositeSelected) {
            swal("This tooth is already selected on opposite");
            break;
          }
        }

        anchorageMesh.isSelected = isSelected;
        color = anchorageMesh.isSelected ? color : "#FFFFFF";
        anchorageMesh.material.color = new THREE.Color(color);
      }

      let selectedMeshes1 = anchorageScene1.children.filter(
        (x) => x.model && x.isSelected,
      );
      let selectedMeshes2 = anchorageScene2.children.filter(
        (x) => x.model && x.isSelected,
      );
      anchorContext.isDirectionEnabled =
        selectedMeshes1.length > 0 && selectedMeshes2.length > 0;
      if (!anchorContext.isDirectionEnabled) {
        anchorContext.isMove1 = anchorContext.isMove2 = false;
        if (moveArrow1) {
          anchorageScene1.remove(moveArrow1);
        }
        if (moveArrow2) {
          anchorageScene2.remove(moveArrow2);
        }
      }

      break;
    }
  }
}

function updateAnchorRaycaster(x, y, container, scene) {
  let rect = container.getBoundingClientRect();
  let width = rect.width;
  let height = rect.height;
  let mouse3D = new THREE.Vector3(
    (x / width) * 2 - 1,
    -(y / height) * 2 + 1,
    0.5,
  );

  mouse3D.unproject(scene.camera);
  mouse3D.sub(scene.camera.position);
  mouse3D.normalize();

  scene.raycaster.set(scene.camera.position, mouse3D);
}

/// !!!
function getFromToDirection(tooth, anchorObj) {
  if (!anchorObj) {
    let mainMeshes1 = anchorageScene1.children
      .filter((x) => x.model && x.isSelected)
      .map((x) => x.mainMesh);
    let mainMeshes2 = anchorageScene2.children
      .filter((x) => x.model && x.isSelected)
      .map((x) => x.mainMesh);
    anchorObj = calculateAnchorObj(mainMeshes1, mainMeshes2);
  }
  let teeth1 = anchorageScene1.children
    .filter((x) => x.model && x.isSelected)
    .map((x) => x.model);
  let teeth2 = anchorageScene2.children
    .filter((x) => x.model && x.isSelected)
    .map((x) => x.model);
  let isFirstGroup = teeth1.includes(tooth);
  let oppositeTeeth = isFirstGroup ? teeth2 : teeth1;
  let anyOppositeIncisors = areAnyIncisors(oppositeTeeth);
  let targetPoint = anchorObj.centerPoint;
  targetPoint = isFirstGroup ? anchorObj.mcenter2 : anchorObj.mcenter1;

  // let tooth = anchorageMesh.model;
  let mainMesh = viewer.get_model_mesh(tooth.id);
  let from = mainMesh.position.clone();
  from.y = tooth.isUpper
    ? maxillaBox.min.y + arrowSize / 2
    : mandibleBox.max.y - arrowSize / 2;
  let to = from.clone(); // new THREE.Vector3();
  let neighborTooth = getLessNeighborTooth(tooth);
  if (tooth.number % 10 == 1 || tooth.number % 10 == 2) {
    to.z = from.z - minArrowLength;
  } else if (anyOppositeIncisors && neighborTooth) {
    let neighborMesh = viewer.get_model_mesh(neighborTooth.id);
    to = neighborMesh.position.clone();
    to.y = from.y;
  } else {
    to.x = targetPoint.x;
    to.z = targetPoint.z;
    let distance = calculateDistance(from, to);
    if (distance < minArrowLength) {
      var rel = minArrowLength / distance;
      var dx = to.x - from.x;
      var dy = to.y - from.y;
      var dz = to.z - from.z;
      to = new THREE.Vector3(from.x + dx * rel, from.y, from.z + dz * rel);
    }
  }
  mainMesh.anchorDirection = new THREE.Vector3().subVectors(to, from);
  // mainMesh.anchorDirection.normalize();
  return { from, to };
}

//#endregion

//#region Report

let isAnimating = false;
function showAnimation() {
  isAnimating = !isAnimating;
  anchorageScene1.mixers = [];
  let meshes1 = anchorageScene1.children.filter((x) => x.model && x.isSelected);
  if (isAnimating) {
    for (const mesh of meshes1) {
      mesh.defaultPosition = mesh.position.clone();
      let x = mesh.position.x;
      let y = mesh.position.y;
      let z = mesh.position.z;

      const positionKF = new THREE.VectorKeyframeTrack(
        ".position",
        [0, 1, 2],
        [x, y, z, x, y, z - 15, x, y, z],
      );
      const clip = new THREE.AnimationClip("Action", 3, [positionKF]);
      let mixer = new THREE.AnimationMixer(mesh);
      const clipAction = mixer.clipAction(clip);
      clipAction.play();
      anchorageScene1.mixers.push(mixer);
    }
  } else {
    for (const mesh of meshes1) {
      mesh.position.copy(mesh.defaultPosition);
    }
  }
}

function generateAnchorageData(isAnimation) {
  let currentSourceType = vueApp.viewSourceType;
  switchStitching("cbct");

  let meshes1 = [];
  let meshes2 = [];

  let anchorageTeeth1 = [];
  anchorageScene1.children.forEach((anchorageMesh) => {
    if (anchorageMesh.model && anchorageMesh.isSelected) {
      anchorageTeeth1.push(anchorageMesh.model);
      meshes1.push(anchorageMesh.mainMesh);
    }
  });
  if (!anchorageTeeth1.length) {
    swal("Select teeth for anchorage");
    return;
  }

  let anchorageTeeth2 = [];
  anchorageScene2.children.forEach((anchorageMesh) => {
    if (anchorageMesh.model && anchorageMesh.isSelected) {
      anchorageTeeth2.push(anchorageMesh.model);
      meshes2.push(anchorageMesh.mainMesh);
    }
  });
  if (!anchorageTeeth2.length) {
    swal("Select opposing teeth for anchorage");
    return;
  }

  let allAnchorageTeeth = anchorageTeeth1.concat(anchorageTeeth2);
  let allMeshes = meshes1.concat(meshes2);
  let meshesBox = getMeshesBox(allMeshes);
  let vcenter = new THREE.Vector3(
    meshesBox.center.x,
    meshesBox.center.y,
    meshesBox.center.z,
  );

  $("#anchorageSpinner").css({ display: "block" });

  setTimeout(() => {
    generateRootCrownMeshes();
    let anchorObj = calculateAnchorObj(meshes1, meshes2);
    for (const tooth of allAnchorageTeeth) {
      getFromToDirection(tooth, anchorObj);
    }
    anchorObj = calculateAnchorAreas(meshes1, meshes2);

    // drawBox(meshesBox, 0xFF00, viewer);
    // $("#anchorageWizard").modal("hide");
    // prepareViewToTooth(anchorageTeeth1[0], vcenter);
    // return;
    // debugAnchorageResult(
    //   meshes1,
    //   meshes2,
    //   allAnchorageTeeth,
    //   mainColor,
    //   opposingColor
    // );
    // return;

    console.log(
      "generateAnchorageData",
      meshesBox,
      anchorageTeeth1,
      anchorageTeeth2,
    );
    vueApp.leaveModes(true, false, false);

    allAnchorageTeeth.forEach((tooth, index) => {
      let anchorCenter = anchorageTeeth1.includes(tooth)
        ? anchorObj.mcenter2
        : anchorObj.mcenter1;
      setToothPointsOfView(tooth, anchorCenter.clone(), index);
    });

    let hasUpper = !!allAnchorageTeeth.find((t) => t.isUpper);
    let hasLower = !!allAnchorageTeeth.find((t) => !t.isUpper);
    let hasBoth = hasUpper && hasLower;

    let center = allTeethCenter;
    if (!hasBoth) {
      center = hasUpper ? maxillaCenter : mandibleCenter;
    }
    resetCameraUp();

    const cDistance = isAnimation ? 150 : 50;
    let centersDistance = calculateDistance(vcenter, center);
    let coef = (centersDistance + cDistance) / centersDistance;

    let px = (vcenter.x - center.x) * coef + center.x;
    let py = (vcenter.y - center.y) * coef + center.y;
    let pz = (vcenter.z - center.z) * coef + center.z; // (vcenter.z - center.z) * coef + center.z; // vcenter.z;
    let centerCameraPoint = new THREE.Vector3(px, py, pz);

    viewer.camera.position.copy(centerCameraPoint);
    vueApp.lookAtPoint(vcenter);
    anchorObj.cameraPoint = centerCameraPoint;
    anchorObj.targetPoint = vcenter;
    // viewer.camera.position.z = defaultZoom / 4 + meshesBox.center.z;

    if (!isAnimation) {
      let canvas = viewer.renderer.domElement;
      canvas.setAttribute("hidden", "hidden");

      //#region prepare main view to screenshot

      let e = viewer.parent_element.getBoundingClientRect();
      let t = e.width;
      let a = t * 0.7;
      viewer.camera.aspect = t / a;
      viewer.camera.updateProjectionMatrix();
      viewer.renderer.setSize(t, a);

      vueApp.allItems.forEach((item) => {
        let mesh = viewer.get_model_mesh(item.id);
        if (mesh && mesh.geometry) {
          let isBone =
            vueApp.bones.includes(item) &&
            (hasBoth ||
              (item.isMaxilla && hasUpper) ||
              (!item.isMaxilla && hasLower));
          let isAnchorageTooth = allAnchorageTeeth.includes(item);
          if (isBone) {
            mesh.visible = true;
            mesh.material.opacity = 0.3;
          } else {
            mesh.visible = isAnchorageTooth;
          }

          if (isAnchorageTooth) {
            let isOpposite = !anchorageTeeth1.includes(item);
            let rootColor = isOpposite ? opposingColor : mainColor;
            let m1 = mesh.originalMaterial.clone();
            m1.color = new THREE.Color("#FFFFFF");
            let m2 = mesh.originalMaterial.clone();
            m2.color = new THREE.Color(rootColor);
            let materials = [m1, m2, m1.clone()]; // m1.clone(),
            mesh.material = materials;
            mesh.geometry = mesh.anchoredGeometry;
          }
        } else {
          console.log("anchorage", item.name);
        }
      });

      //#endregion

      const tmt = 150;
      const totalImgCount = 2 + allAnchorageTeeth.length;
      const imgArr = [];
      for (let i = 0; i < totalImgCount; i++) {
        setTimeout(function () {
          imgArr.push(getImgDataForCurrentView());
          if (i === 0) {
            prepareToOcclusal(hasUpper, allAnchorageTeeth, anchorageTeeth1);
          } else {
            let tooth = allAnchorageTeeth[i - 1];
            let isOpposite = anchorageTeeth2.includes(tooth);
            if (tooth) prepareViewToTooth(tooth, vcenter, isOpposite);
          }
        }, (i + 1) * tmt);
      }

      setTimeout(() => {
        generateAnchoragePdf(
          anchorageTeeth1,
          anchorageTeeth2,
          imgArr,
          anchorObj,
        );

        switchStitching(currentSourceType);
        // $("#anchorageWizard").modal("hide");

        viewer.do_resize();
        vueApp.leaveModes(true, false, false);
        vueApp.switchToDefaultView();
        canvas.removeAttribute("hidden");
        $("#anchorageSpinner").css({ display: "none" });
      }, (totalImgCount + 1) * tmt);
    } else {
      enterAnchorageAnimationMode(
        anchorObj,
        anchorageTeeth1,
        anchorageTeeth2,
        currentSourceType,
      );
    }
  }, 100);
}

function generateAnchoragePdf(
  anchorageTeeth1,
  anchorageTeeth2,
  imgArr,
  anchorObj,
) {
  const pdf = new jsPDF();
  console.log("generateAnchoragePdf", pdf.getFontList());
  const pdfWidth = pdf.internal.pageSize.getWidth(); // 210
  const pdfHeight = pdf.internal.pageSize.getHeight(); // 297
  pdf.setFontSize(18);
  pdf.setFont("helvetica");
  const lineHeightFactor = 0.7;

  const headerText = "Anchorage Report";
  let headerDims = pdf.getTextDimensions(headerText);
  let headerWidth = headerDims.w;
  let headerHeight = headerDims.h;
  let headerTop = headerHeight * 1.5;
  const headerLeft = pdfWidth / 2 - headerWidth / 2;
  pdf.text(headerText, headerLeft, headerTop);

  let fontSize = 12;
  pdf.setFontSize(fontSize);
  let textLeft = 15;
  let textTop = headerTop + headerHeight * 2;

  let patientName = `Patient name: ${vueApp.patientFirstName} ${vueApp.patientLastName}`;
  let textDims = pdf.getTextDimensions(patientName);
  let textHeight = textDims.h;
  let lineHeight = textHeight * 2 * lineHeightFactor;
  pdf.text(patientName, textLeft, textTop);
  textTop += lineHeight;

  const lineDif = 0.5;
  const anchorText1 = "Anchor 1:";
  textDims = pdf.getTextDimensions(anchorText1);
  let lineTop = textTop + 1;
  pdf.line(
    textLeft - lineDif,
    lineTop,
    textLeft + textDims.w + lineDif,
    lineTop,
  );
  pdf.text(anchorText1, textLeft, textTop);
  textTop += lineHeight;

  let areInDifferentQuarters = false;
  let allAnchorageTeeth = anchorageTeeth1.concat(anchorageTeeth2);
  let quarters = [];
  allAnchorageTeeth.forEach((tooth) => {
    let quarter = +(tooth.number + "")[0];
    // console.log("quarter", quarter);
    let oppositeQuarter = quarters.find((q) => Math.abs(q - quarter) === 1);
    if (oppositeQuarter) {
      areInDifferentQuarters = true;
    }
    quarters.push(quarter);
  });
  // console.log("areInDifferentQuarters", areInDifferentQuarters);

  let lastNumber1 = +anchorageTeeth1[0].number % 10;
  let lastNumber2 = +anchorageTeeth2[0].number % 10;

  let side1 =
    areInDifferentQuarters || lastNumber1 > lastNumber2 ? "Mesial" : "Distal";
  anchorageTeeth1.forEach((tooth) => {
    let mesh = viewer.get_model_mesh(tooth.id);
    let area = mesh.anchorArea;
    let toothText = `Selected tooth ${tooth.number}. Bone interface area ${area} mm^2 on ${side1} side`;
    pdf.text(toothText, textLeft + 5, textTop);
    textTop += lineHeight;
  });
  let totalText = `Total: ${anchorObj.anchorTotal1.toFixed(1)} mm^2`;
  pdf.text(totalText, textLeft + 5, textTop);
  textTop += lineHeight;

  const anchorText2 = "Anchor 2:";
  textDims = pdf.getTextDimensions(anchorText2);
  lineTop = textTop + 1;
  pdf.line(
    textLeft - lineDif,
    lineTop,
    textLeft + textDims.w + lineDif,
    lineTop,
  );
  pdf.text(anchorText2, textLeft, textTop);
  textTop += lineHeight;

  let side2 =
    areInDifferentQuarters || lastNumber2 > lastNumber1 ? "Mesial" : "Distal";
  anchorageTeeth2.forEach((tooth) => {
    let mesh = viewer.get_model_mesh(tooth.id);
    let area = mesh.anchorArea;
    let toothText = `Selected tooth ${tooth.number}. Bone interface area: ${area} mm^2 on ${side2} side`;
    pdf.text(toothText, textLeft + 5, textTop);
    textTop += lineHeight;
  });
  totalText = `Total: ${anchorObj.anchorTotal2.toFixed(1)} mm^2`;
  pdf.text(totalText, textLeft + 5, textTop);
  textTop += lineHeight * 1.5;

  let anchorNumber = lastNumber2 > lastNumber1 ? 2 : 1;
  // let positiveAnchorage = Math.abs(anchorTotal1 - anchorTotal2).toFixed(1);
  let positiveText = `Anchor ${anchorNumber} has a positive anchorage of ${anchorObj.positiveAnchorage} on ${side2} side`;
  pdf.text(positiveText, textLeft, textTop);
  textTop += lineHeight;

  let expectedTitle = `Expected movement:`;
  pdf.text(expectedTitle, textLeft, textTop);
  textTop += lineHeight;

  // let expectedMove1 = 1 - anchorTotal1 / (anchorTotal1 + anchorTotal2);
  let expectedMove1 = (anchorObj.expectedMove1 * 100).toFixed(0);
  let expectedText1 = `Anchor 1 is expected to move: ${expectedMove1} %`;
  pdf.text(expectedText1, textLeft + 5, textTop);
  textTop += lineHeight;

  // let expectedMove2 = 1 - anchorTotal2 / (anchorTotal1 + anchorTotal2);
  let expectedMove2 = (anchorObj.expectedMove2 * 100).toFixed(0);
  let expectedText2 = `Anchor 2 is expected to move: ${expectedMove2} %`;
  pdf.text(expectedText2, textLeft + 5, textTop);
  textTop += lineHeight * 0.7;

  let imgData = imgArr[0];
  let imgProps = pdf.getImageProperties(imgData);

  const marginTop = 2;
  const marginLeft = textLeft;

  const teethImagesHeight = 100;
  let imgMaxWidth = (pdfWidth - marginLeft) / 2 - marginTop;
  let imgMaxHeight = pdfHeight - textTop - marginTop - teethImagesHeight;
  let imgWidthRel = imgMaxWidth / imgProps.width;
  let imgHeightRel = imgMaxHeight / imgProps.height;
  let imgMinRel = Math.min(imgWidthRel, imgHeightRel);
  let imgWidth = imgProps.width * imgMinRel;
  let imgHeight = imgProps.height * imgMinRel;

  let imgLeft = marginLeft;
  let imgTop = textTop;
  pdf.addImage(imgData, "JPEG", imgLeft, imgTop, imgWidth, imgHeight);

  let imgLeft2 = marginLeft + imgWidth + marginTop; //pdfWidth / 2;
  imgData = imgArr[1];
  pdf.addImage(imgData, "JPEG", imgLeft2, imgTop, imgWidth, imgHeight);

  textTop += imgHeight + lineHeight * 1.4;

  const atext1 = "Anchor 1 bone interface";
  const atext2 = "Anchor 2 bone interface";
  pdf.text(atext1, textLeft, textTop);
  pdf.text(atext2, imgLeft2, textTop);
  textTop += lineHeight * 0.7;

  imgMaxWidth = pdfWidth / 8;
  imgData = imgArr[2];
  imgProps = pdf.getImageProperties(imgData);
  imgWidthRel = imgMaxWidth / imgProps.width;
  imgHeightRel = imgMaxHeight / imgProps.height;
  imgMinRel = Math.min(imgWidthRel, imgHeightRel);
  imgWidth = imgProps.width * imgMinRel;
  imgHeight = imgProps.height * imgMinRel;

  let i = 1;
  imgLeft = marginLeft;
  if (!vueApp.isWhite) pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(fontSize - 1);
  anchorageTeeth1.forEach((tooth, index) => {
    let toothImageData = imgArr[++i];
    if (index > 2) imgLeft = marginLeft;
    imgTop = index < 3 ? textTop : textTop + imgHeight + marginTop;
    pdf.addImage(toothImageData, "JPEG", imgLeft, imgTop, imgWidth, imgHeight);
    pdf.text(tooth.name, imgLeft + 1, imgTop + imgHeight - 1);
    imgLeft += imgWidth + 2;
  });

  imgLeft = imgLeft2;
  anchorageTeeth2.forEach((tooth, index) => {
    let toothImageData = imgArr[++i];
    if (index > 2) imgLeft = imgLeft2;
    imgTop = index < 3 ? textTop : textTop + imgHeight + marginTop;
    pdf.addImage(toothImageData, "JPEG", imgLeft, imgTop, imgWidth, imgHeight);
    pdf.text(tooth.name, imgLeft + 1, imgTop + imgHeight - 1);
    imgLeft += imgWidth + 2;
  });

  pdf.setTextColor(0, 0, 0);
  pdf.setFont(undefined, "bold");
  pdf.setFontSize(fontSize - 1);
  textTop = pdfHeight - lineHeight * 2.4;
  let noteText =
    "Please note - percentage movement is only an approximation and depends on the accuracy of the segmentation and varying differences in bone density and the amount of tipping and/or bodily movement required.";
  // noteText = pdf.splitTextToSize(noteText, pdfWidth - textLeft * 2);
  pdf.text(noteText, textLeft, textTop, {
    maxWidth: pdfWidth - textLeft * 2,
    align: "justify",
  });

  //_${vueApp.patientFirstName}_${vueApp.patientLastName}
  let fullName = `anchorageReport_${getFormattedDate(true)}.pdf`;
  pdf.save(fullName);
}

function prepareToOcclusal(isMaxilla, allAnchorageTeeth, anchorageTeeth1) {
  vueApp.allTeeth.forEach((tooth) => {
    let mesh = viewer.get_model_mesh(tooth.id);
    mesh.visible =
      tooth.isVisible &&
      (tooth.isUpper == isMaxilla || allAnchorageTeeth.includes(tooth));
    mesh.material = mesh.originalMaterial;

    if (mesh.visible) {
      if (allAnchorageTeeth.includes(tooth)) {
        let color = anchorageTeeth1.includes(tooth) ? mainColor : opposingColor;
        let material = mesh.originalMaterial
          ? mesh.originalMaterial
          : mesh.material;
        mesh.material = material;
        material.color = new THREE.Color(color);
        let geometry = mesh.stitchedGeometry
          ? mesh.stitchedGeometry
          : mesh.cbctGeometry;
        mesh.geometry = geometry;
      } else {
        mesh.material.color = new THREE.Color("#FFFFFF");
      }
    }
  });
  vueApp.bones.forEach((model) => {
    let mesh = viewer.get_model_mesh(model.id);
    mesh.visible = false;
  });
  // vueApp.lookAtPoint(new THREE.Vector3());
  // resetCameraUp();

  if (isMaxilla) switchToMaxilla(true);
  else switchToMandibular(true);
}

function setToothPointsOfView(tooth, anchorCenter, index) {
  // console.log("setPointOfView", tooth.filename);
  let mesh = viewer.get_model_mesh(tooth.id);

  if (mesh) {
    let toothBox = tooth.defaultBox;
    let toothGeometry = mesh.stitchedGeometry
      ? mesh.stitchedGeometry
      : mesh.geometry;
    toothGeometry.computeBoundingBox();
    toothBox = offsetBox(
      toothGeometry.boundingBox,
      mesh.position.x,
      mesh.position.y,
      mesh.position.z,
    );
    mesh.anchorGeometryCenter = new THREE.Vector3(
      toothBox.center.x,
      toothBox.center.y,
      toothBox.center.z,
    );

    // if (mesh.filteredGeometry) {
    //   toothBox = mesh.filteredGeometry.boundingBox;
    //   toothBox = offsetBox(
    //     toothBox,
    //     mesh.position.x,
    //     mesh.position.y,
    //     mesh.position.z
    //   );
    //   mesh.anchorGeometryCenter = new THREE.Vector3(
    //     toothBox.center.x,
    //     toothBox.center.y,
    //     toothBox.center.z
    //   );
    // }

    let x = toothBox.center.x;
    // let y = tooth.isMaxilla ? toothBox.min.y + view_dy : toothBox.max.y;
    let y = toothBox.center.y;
    let z = toothBox.center.z;
    // drawPoint(mesh.anchorGeometryCenter);

    anchorCenter.y = y;

    let distance = calculateDistance(mesh.anchorGeometryCenter, anchorCenter);
    let coef = (distance + cameraDistance) / distance;
    let px = (anchorCenter.x - x) * coef + anchorCenter.x;
    let py = (anchorCenter.y - y) * coef + anchorCenter.y;
    let pz = (anchorCenter.z - z) * coef + anchorCenter.z;
    // let px = (x - anchorCenter.x) * coef + anchorCenter.x;
    // let py = (y - anchorCenter.y) * coef + anchorCenter.y;
    // let pz = (z - anchorCenter.z) * coef + anchorCenter.z;

    // py += tooth.isMaxilla ? -2 : 2;

    mesh.anchorCameraPoint = new THREE.Vector3(px, py, pz);
    // if (!index) {
    //   drawLine(mesh.anchorCameraPoint, mesh.anchorGeometryCenter, 0xff0000);
    // } else {
    //   drawLine(mesh.anchorCameraPoint, mesh.anchorGeometryCenter, 0x00ff00);
    // }
  }
}

function prepareViewToTooth(tooth, anchorCenter, isOpposite) {
  let toothMesh = null;
  vueApp.allItems.forEach((model) => {
    let mesh = viewer.get_model_mesh(model.id);
    if (!mesh || !mesh.geometry) return;
    mesh.visible = tooth == model;
    if (mesh.visible) {
      toothMesh = mesh;
      mesh.geometry = mesh.anchoredGeometry;
      let rootColor = isOpposite ? opposingColor : mainColor;
      let m1 = mesh.originalMaterial.clone();
      m1.color = new THREE.Color("#FFFFFF");
      let m2 = mesh.originalMaterial.clone();
      m2.color = new THREE.Color(rootColor);
      let materials = [m1, m2, m1.clone()]; // m1.clone(),
      mesh.material = materials;
    }
  });

  let e = viewer.parent_element.getBoundingClientRect();
  let t = e.width;
  let a = t * 1.4;
  viewer.camera.aspect = t / a;
  viewer.camera.updateProjectionMatrix();
  viewer.renderer.setSize(t, a);

  resetCameraUp();

  let toothCenter = toothMesh.anchorGeometryCenter;
  viewer.camera.position.copy(toothMesh.anchorCameraPoint);

  vueApp.lookAtPoint(toothCenter);
  viewer.camera.updateProjectionMatrix();
  viewer.controls.update();
}

//#endregion

export {
  mainColor,
  opposingColor,
  enterAnchorageMode,
  switchToMaxilla1,
  switchToMandibular1,
  switchToMaxilla2,
  switchToMandibular2,
  generateAnchorageData,
  switchDirectionMode,
  addSceneLights,
};
